import { Service } from '@angular/core';
import { State } from '@ngxs/store';
import { CollectionDataServiceBase } from '@portal-core/data/collection/services/collection-data.service.base';
import { CollectionStateSelectors } from '@portal-core/data/collection/services/collection-state-selectors.decorator';
import { CollectionStateBase } from '@portal-core/data/collection/services/collection-state.base';
import { ProjectChecklist } from '@portal-core/project-checklists/models/project-checklist.model';

@CollectionStateSelectors({
  stateType: ProjectChecklistsState
})
@State<ProjectChecklistsState>({
  name: ProjectChecklistsState.source
})
@Service({ autoProvided: false })
export class ProjectChecklistsState extends CollectionStateBase {
  static override source = 'ProjectChecklists';
  getSource(): string {
    return ProjectChecklistsState.source;
  }
}

@Service()
export class ProjectChecklistsDataService extends CollectionDataServiceBase<ProjectChecklist> {
  protected readonly stateType = ProjectChecklistsState;
}
